module.exports = __webpack_public_path__ + "media/images/digivent/avatars/AVATAR-26-5257c81ed4b4a35d0c02a6d23632187f.png";